export const TimeSlotGridSkeleton = () => {
    return Array.from({ length: 8 }).map((_, index) => (
        <div
            key={index}
            className="h-10 animate-pulse rounded-lg bg-gray-200"
        />
    ));
};
